const shots = [
  { src: "/images/gary-stage-spotlights.jpg", caption: "Theater Stage · Spotlights & Packed House", span: "md:col-span-2 md:row-span-2" },
  { src: "/images/gary-you-got-this.jpg", caption: "'You've Got This!' Keynote · Main Stage" },
  { src: "/images/gary-oh-yeah.jpg", caption: "Full-Energy Delivery · Conference Keynote" },
  { src: "/images/gary-seminar-ballroom.jpg", caption: "Ballroom Seminar · Hotel Conference" },
  { src: "/images/gary-banquet-closeup.jpg", caption: "Corporate Keynote · Pink Pocket Square" },
  { src: "/images/gary-banquet.jpg", caption: "Packed Ballroom · Association Event" },
  { src: "/images/gary-back-of-room.jpg", caption: "Theater-Style Event · Live Audience" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">09 / LIVE ON STAGE</span>
          <div className="divider-red" />
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2 className="h-display text-5xl md:text-6xl lg:text-7xl max-w-3xl">
            The room when <span className="text-[#EC1985]">Gary's in it.</span>
          </h2>
          <p className="text-white/70 max-w-md text-lg">
            5,000 or 50 — every audience walks out feeling personally seen.
            These are real moments from real events.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 grid-rows-2 gap-4 md:auto-rows-[260px]">
          {shots.map((s, i) => (
            <figure
              key={i}
              data-testid={`gallery-${i}`}
              className={`relative group overflow-hidden border border-[#262626] ${s.span || ""}`}
            >
              <img
                src={s.src}
                alt={s.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/95 via-[#050505]/30 to-transparent opacity-90" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-xs uppercase tracking-[0.2em] text-[#EC1985] font-bold mb-1">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="text-white text-sm md:text-base font-bold">{s.caption}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
